<template>
        <div :class="{ active: isActive, 'scrolled-class': isScrolled }" class="sidebar">
          <ul>
            <!-- <li><router-link to="/brand/build-your-campaign">+ <span>Campaign</span></router-link></li> -->
            <li><router-link to="/brand/choose-profession"><img src="/img/medal_star.png"> <span>Onboarding</span></router-link></li>
            <li><router-link to="/brand/build-your-campaign"><img src="/img/sidebar1.png"> <span>Home</span></router-link></li>
            <li><router-link to="/brand/build-your-mix-campaign"><img src="/img/sidebar1.png"> <span>Workflow</span></router-link></li>
            <li><router-link to="/brand/manage-campaign"><img src="/img/white_pickl.png"> <span>Manage Campaigns</span></router-link>

              <!-- <ul>
                <li><router-link to="/brand/build-your-campaign">Build Campaign</router-link></li>
                <li><router-link to="/brand/manage-campaign">Manage Campaigns</router-link></li>
                <li><router-link to="/brand/media">Media Directory</router-link></li>
                <li><router-link to="/brand/insights">Consumer Questions</router-link></li>
                <li><router-link to="/brand/products">Products and Activities</router-link></li>
                <li><router-link to="/brand/coupons">Coupons</router-link></li>
                <li><router-link to="/brand/saved-location-settings">Location Bundles</router-link></li>
              </ul> -->
            </li>
            <li><a href="#"><img src="/img/sidebar2.png"> <span>Data <img src="/img/next_arrow.png"></span></a>
              <ul>
                <li><router-link to="/brand/data-analysis">Data Visuals</router-link></li>
                <li><router-link to="/brand/campaigns-data">Survey Result</router-link></li>
              </ul>
            </li>
            <li><a href="#"><img src="/img/sidebar8.png"> <span>Activities <img src="/img/next_arrow.png"></span></a>
              <ul>
                <li><router-link to="/brand/non-geo-pickl-history?status=PENDING">Any Location</router-link></li>
                <li><a href="/brand/pickl-history?status=PENDING">Specific Location</a></li>
                <li><router-link to="/brand/image-gallery">Activity Images</router-link></li>
              </ul>
            </li>
            <!-- <li><router-link to="/brand/tutorial-videos"><img src="/img/sidebar3.png"> <span>Tutorials</span></router-link></li> -->
          </ul>
          <a href="#" @click="toggleSidebar" class="expand_sidebar_button"><img src="/img/expand_sidebar.png"></a>
        </div> 
</template>
<script>
import '@/assets/css/sidebar.css'
export default {
  name: 'BrandSidebarComponet',
  data() {
    return {
      isActive: false
    };
  },
  mounted () {
  },
  methods: {
    toggleSidebar() {
      this.isActive = !this.isActive;
    }
  },
  watch:{
    $route (to, from){
      if (to.fullPath !== from.fullPath) {
        this.isActive = false;

      }
    }
} 
}
</script>
